var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#DDD",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 26.125C16.4393 26.4856 16.6591 26.8022 16.96 27.0274 17.2608 27.2526 17.6265 27.3743 18.0022 27.3743 18.378 27.3743 18.7437 27.2526 19.0445 27.0274 19.3454 26.8022 19.5651 26.4856 19.671 26.125M18 10.5V8.625M18 10.5C19.6576 10.5 21.2473 11.1585 22.4194 12.3306 23.5915 13.5027 24.25 15.0924 24.25 16.75 24.25 22.6217 25.5 23.625 25.5 23.625H10.5C10.5 23.625 11.75 22.0283 11.75 16.75 11.75 15.0924 12.4085 13.5027 13.5806 12.3306 14.7527 11.1585 16.3424 10.5 18 10.5V10.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H20V20H0z",
    transform: "translate(8 8)"
  })))));
};
export default SvgBell;